/* ========================================================================
 * FD:          FD
 * Child:       SITESEARCH
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * handle site search
 * ======================================================================== 
 * 12/18/2015: creation
*/

FD.SITE = (function ($, me) {
    'use strict';

    var child = me.SITE || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */
    var ELEM = 'SITE_SEARCH';
    var searchInput = $('#' + ELEM);           //  the search input box
    var ELEM_SEARCH_TAB = '#SITE_SEARCH_TABS';

    //  set in contructor [ all refererences to specific elements ]
    var elem = {};
    var siteSearchType = {
        Undefined: 0,
        Application: 1,
        Team: 2,
        Document: 3,
        CR: 4,
        Entity: 5,
    }

    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    //  set site search control
    function setSiteSearchcontrol() {
        var NAMESPACE = me.getUID('NS_');
        var searchTabs = $(ELEM_SEARCH_TAB).children('li');

        //  set all the search containers
        elem = {
            searchInput: searchInput,
            historyList: $('#SS_HISTORY_CONTENT'),
            favoriteViewList: $('#SS_FAVORITES_CONTENT'),
            searchTerm: $('#SS_SEARCHTERM'),
            searchTermCount: $('#SS_SEARCHTERM_COUNT'),          
            appsCount: $('#SS_APPS_COUNT'),
            teamCount: $('#SS_TEAM_COUNT'),
            docsCount: $('#SS_DOCS_COUNT'),
            crCount: $('#SS_CR_COUNT'),
            entityCount: $('#SS_ENTITY_COUNT'),
            appsList: $('#SS_APPS_CONTENT'),
            teamList: $('#SS_TEAM_CONTENT'),
            docsList: $('#SS_DOCS_CONTENT'),
            crList: $('#SS_CR_CONTENT'),
            entityList: $('#SS_ENTITY_CONTENT'),
            curSearch: '',
            currentTab: siteSearchType.Application,
            tabList: [
                null,
                $(searchTabs[0]),
                $(searchTabs[1]),
                $(searchTabs[2]),
                $(searchTabs[3]),
                $(searchTabs[4]),
            ]
        };



        //  set the search history event
        function onClickHistory(event) {
            event.preventDefault();
            var val = $(this).text();
            elem.searchInput.val(val);

            getSiteSearchResults();
        }

        elem.historyList.on('click.shistory' + NAMESPACE, 'li a', onClickHistory);
    }




    /* ========================================================================
     *  get search results
     * ========================================================================
    */

    //  get search results
    function getSiteSearchResults() {
        //  do the search for all
        var val = searchInput.val();
        val = me.setHtmlEncode(val);
        val = val.trim();

        //  bail if input same
        if (elem.curSearch === val) return;

        //  set search term
        elem.curSearch = val;


        //  get search
        getSearchFromDB();
    }


    function getTabSearchResults(tabType) {
        var URL = "/Common/Common/GetSiteSearchTab";

        var inputProps = {
            searchTerm: elem.curSearch,
            searchType: elem.currentTab
        };

        var options = {
            params: inputProps,
            url: URL,
            callback: afterData,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            switch (elem.currentTab) {
                case siteSearchType.Application:
                    elem.appsList.html(result);
                    break;
                case siteSearchType.Team:
                    elem.teamList.html(result);
                    break;
                case siteSearchType.Document:
                    elem.docsList.html(result);
                    break;
                case siteSearchType.CR:
                    elem.crList.html(result);
                    break;
                case siteSearchType.Entity:
                    elem.entityList.html(result);
                    break;
            }

            elem.tabList[elem.currentTab].find('a').data('loaded', true).attr('data-loaded', true).tab('show');
        }
    }




    //  get actual search results from db
    function getSearchFromDB() {
        if (!elem || !elem.searchTerm) {
            return false;
        }
        
        var URL = "/Common/Common/GetSiteSearch";

        var inputProps = {
            searchTerm: elem.curSearch,
            searchType: elem.currentTab
        };

        var options = {
            params: inputProps,
            url: URL,
            callback: afterData
        };
        me.AJAX.setAJAX(options);

        //  set search title
        elem.searchTerm.html(elem.curSearch);

        function afterData(data) {
            var result = data.data;

            switch (result.ActiveTab) {
                case siteSearchType.Application:
                    elem.appsList.html(result.CurrentView);
                    break;
                case siteSearchType.Team:
                    elem.teamList.html(result.CurrentView);
                    break;
                case siteSearchType.Document:
                    elem.docsList.html(result.CurrentView);
                    break;
                case siteSearchType.CR:
                    elem.crList.html(result.CurrentView);
                    break;
                case siteSearchType.Entity:
                    elem.entityList.html(result.CurrentView);
                    break;
            }

            elem.historyList.html(result.SearchHistoryView);
            elem.favoriteViewList.html(result.FavoriteViewHTML);

            elem.appsCount.html('(' + result.ApplicationCount + ')');
            elem.teamCount.html('(' + result.TeamCount + ')');
            elem.docsCount.html('(' + result.DocumentCount + ')');
            elem.crCount.html('(' + result.CRCount + ')');
            elem.entityCount.html('(' + result.EntityCount + ')');
            elem.searchTermCount.html('(' + result.TotalSearchCount + ')');

            // reset loaded status
            for (var x = 0; x < elem.tabList.length; x++) {
                if (elem.tabList[x]) {
                    elem.tabList[x].find('a').data('loaded', false).attr('data-loaded', false);
                }
            }

            if (result.ActiveTab != elem.currentTab) {
                elem.currentTab = result.ActiveTab;
            }

            if (elem.tabList[elem.currentTab] !== undefined) {
                elem.tabList[elem.currentTab].find('a').data('loaded', true).attr('data-loaded', true).tab('show');
            }


            me.CONTROL.setSortable("#SS_FAVORITES_LIST");
            me.CONTROL.setButton(true, "#POP_SEARCH");
        }
    }






    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set seach on load
    child.setSearchOnload = function () {
        elem.curSearch = '';
        getSearchFromDB();
    };


    //  set site search control
    child.setSiteSearchControl = function () {
        if (searchInput.length === 0) return;
        setSiteSearchcontrol();
    };


    //  get search results
    child.getSiteSearchResults = function () {
        getSiteSearchResults();
    };

    child.getTabSearchResults = function (tabType, tabElem) {
        elem.currentTab = tabType;
        if (!tabElem.data('loaded')) {
            getTabSearchResults(tabType);
        } else {
            tabElem.tab('show');
        }
    }



    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));